import { Component, OnInit, Inject } from '@angular/core';
import { VillageService } from 'src/app/services/village.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AllUtiltesComponent } from '../all-utiltes/all-utiltes.component';
import { ServiceMangeService } from 'src/app/services/service-mange.service';
import {ThemePalette} from '@angular/material/core';

@Component({
  selector: 'app-add-utilty',
  templateUrl: './add-utilty.component.html',
  styleUrls: ['./add-utilty.component.css']
})
export class AddUtiltyComponent implements OnInit {

  all_projects:any

  uitltyName :any
  project_id:any
  measure:any
  statusOfEdit = false
  statusOfImage = false
  utilty_id:any
  utiltyImage: any;
  color: ThemePalette = "primary";
  disabledApp:any = false
  constructor(private rest : VillageService ,
     public dialogRef: MatDialogRef<AllUtiltesComponent>,
     private servMange : ServiceMangeService ,
    @Inject(MAT_DIALOG_DATA) public data: any ){}

  ngOnInit(){
    this.getData()
  }

  getData(){
    console.log(this.data)
    if(this.data){
      this.statusOfEdit = true
      this.uitltyName = this.data.name
      this.measure = this.data.unit_measure
      this.utilty_id = this.data.id
    }
    this.rest.villageList().subscribe((res:any) => {
      console.log(res)
      this.all_projects = res
    })
  }

  addUilty(){
    let data = {
      name : this.uitltyName,
      project_id : this.project_id,
      unit_measure :  this.measure,
    }

    this.statusOfImage = true
    this.servMange.addUtilty(data).subscribe((res:any) => {
      console.log(res)
      this.utilty_id = res.utility_id     
    })
  }

  editUitlty(){
    let data = {
      utility_id : this.data.id,
      name : this.uitltyName,
      unit_measure :  this.measure,
      status : this.disabledApp
    }
    // console.log()
    this.dialogRef.close(data);
  }

  uploadUtilityImage(e:any){
    console.log(e.target.value)
    this.utiltyImage = e.target.files[0]
  }

  addUtiltyImage(){
    let data = {
      utility_id : this.utilty_id,
      image : this.utiltyImage,
      status : this.disabledApp
    }
    this.dialogRef.close(data)
  }




}
